import script from "./NoticePublic.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticePublic.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/clubstyle.css?vue&type=style&index=0&lang=css&external"
import "./NoticePublic.vue?vue&type=style&index=1&id=0f1e8c1b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f1e8c1b"]])

export default __exports__